"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsGeneralReportFeedbackControl = void 0;
const Modal_1 = require("../../../../public/js/utils/Modal");
const DOM_1 = require("../../../../public/js/utils/DOM");
const FormValidator_1 = require("../../../../public/js/utils/Validator/FormValidator");
const Netwtorking_1 = require("../../../../public/js/utils/Netwtorking");
const RequestTypes_1 = require("../../../../public/js/definitions/utils/networking/RequestTypes");
const LinkBuilder_1 = require("../../../../public/js/utils/LinkBuilder");
const Form_1 = require("../../Form/Form");
const Notify_1 = require("../../../../public/js/utils/Notify");
const Sentry_1 = require("../../../../public/js/utils/Sentry/Sentry");
var ControlsGeneralReportFeedbackControl;
(function (ControlsGeneralReportFeedbackControl) {
    class Config {
        static component = 'reportFeedback';
        static modalId = "reportModal";
        static showModalBackendCallback = "Show";
        static triggerButton = "reportModalButton";
        static submitButtonId = "reportFeedbackSaveSubmit";
        static formId = "reportFeedbackForm";
        static translationsElementId = "jsTranslations";
        static translationReportSuccess = "trsReportSuccess";
        static translationExceptionSuccess = "trsExceptionSuccess";
    }
    ControlsGeneralReportFeedbackControl.Config = Config;
    class Control {
        static initialize() {
            Modal_1.Modal.Helpers.initModalTriggersByModalId(Config.modalId);
            this.initializeShowModal();
        }
        static initializeShowModal() {
            if (!document.getElementById(Config.triggerButton)) {
                return;
            }
            DOM_1.DOM.Parser.getHtmlElement(Config.triggerButton).addEventListener('click', () => {
                this.doShowModal(false, null);
            });
        }
        static doShowModal(isError, sentryEventId) {
            void Netwtorking_1.Networking.NetworkingController.createRequest({
                type: RequestTypes_1.RequestTypes.GET,
                url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                    component: Config.component, method: Config.showModalBackendCallback, parameters: [
                        { name: 'sentryEventId', value: sentryEventId },
                        { name: 'isError', value: isError }
                    ],
                }),
                successCallback: () => {
                    Modal_1.Modal.Helpers.openModalById(Config.modalId);
                    this.triggerSendFeedback();
                }
            });
        }
        static triggerSendFeedback() {
            const formElement = DOM_1.DOM.Parser.getHtmlElement(Config.formId);
            const submitButton = DOM_1.DOM.Parser.getHtmlElement(Config.submitButtonId);
            FormValidator_1.FormValidator.validateForm({ form: formElement, forceSubmitButton: submitButton });
            submitButton.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                const formData = Form_1.ControlsForm.Controller.getFormData(formElement);
                Modal_1.Modal.Helpers.closeModalById(Config.modalId);
                const translationsElement = DOM_1.DOM.Parser.getHtmlElement(Config.translationsElementId);
                (0, Sentry_1.SentryReportUserFeedback)(formData.description, formData.sentryEventId);
                const successTranslationMessage = formData.sentryEventId ? Config.translationExceptionSuccess : Config.translationReportSuccess;
                Notify_1.Notify.Handler.processMessages([{
                        message: DOM_1.DOM.Parser.getDataByNameFromElement(successTranslationMessage, translationsElement),
                        type: 'success',
                        closeModal: null,
                        uniqKeys: null,
                        eventId: null
                    }]);
            });
        }
    }
    ControlsGeneralReportFeedbackControl.Control = Control;
})(ControlsGeneralReportFeedbackControl || (exports.ControlsGeneralReportFeedbackControl = ControlsGeneralReportFeedbackControl = {}));
